import React, { useState, useEffect } from 'react';

const Gallery: React.FC = () => {
  const [showHidden, setShowHidden] = useState(false);

  // 15 gallery images - all in one array for 3 rows of 5
  const allImages = [
    // Row 1 - 5 images
    { src: "premal1.jpeg", alt: "Gallery image 1" },
    { src: "premal2.jpeg", alt: "Gallery image 2" },
    { src: "premal3.jpeg", alt: "Gallery image 3" },
    { src: "img10.jpeg", alt: "Gallery image 4" },
    { src: "img22.jpeg", alt: "Gallery image 5" },
    // Row 2 - 5 images
    { src: "img23.jpeg", alt: "Gallery image 6" },
    { src: "img24.jpeg", alt: "Gallery image 7" },
    { src: "img30.jpeg", alt: "Gallery image 8" },
    { src: "img31.jpeg", alt: "Gallery image 9" },
    { src: "img33.jpeg", alt: "Gallery image 10" },
    // Row 3 - 5 images
    { src: "img34.jpeg", alt: "Gallery image 11" },
    { src: "img36.jpeg", alt: "Gallery image 12" },
    { src: "img16.jpeg", alt: "Gallery image 13" },
    { src: "img17.jpeg", alt: "Gallery image 14" },
    { src: "img19.jpeg", alt: "Gallery image 15" },
  ];

  const visibleImages = allImages.slice(0, 10);
  const hiddenImages = allImages.slice(10);

  const toggleHiddenGallery = () => {
    setShowHidden(!showHidden);
  };

  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    
    const checkReveal = () => {
      reveals.forEach(el => {
        if (el.getBoundingClientRect().top < window.innerHeight - 120) {
          el.classList.add('active');
        }
      });
    };
    
    window.addEventListener('scroll', checkReveal);
    window.addEventListener('load', checkReveal);
    
    return () => {
      window.removeEventListener('scroll', checkReveal);
      window.removeEventListener('load', checkReveal);
    };
  }, []);

  useEffect(() => {
    if (showHidden) {
      const hiddenItems = document.querySelectorAll('.third-row .gallery-item');
      hiddenItems.forEach((item, index) => {
        setTimeout(() => {
          (item as HTMLElement).style.opacity = '1';
          (item as HTMLElement).style.transform = 'translateY(0) scale(1)';
        }, index * 100);
      });
    }
  }, [showHidden]);

  return (
    <section id="gallery" className="reveal">
      <div className="gallery-container">
        <div className="section-header">
          <h2>Our Work & Inventory</h2>
          <p className="section-subtitle">Explore our collection of premium vehicles</p>
        </div>
        
        <div className="gallery-wrapper">
          <div className="gallery-grid">
            {visibleImages.map((img, index) => (
              <div 
                className="gallery-item animate-on-scroll" 
                key={`visible-${index}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="image-wrapper">
                  <img src={img.src} alt={img.alt} loading="lazy" />
                </div>
              </div>
            ))}
          </div>

          {showHidden && (
            <div className="gallery-grid third-row">
              {hiddenImages.map((img, index) => (
                <div 
                  className="gallery-item slide-up" 
                  key={`hidden-${index}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="image-wrapper">
                    <img src={img.src} alt={img.alt} loading="lazy" />
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="gallery-btn-wrapper">
            <button 
              className="btn-gallery" 
              onClick={toggleHiddenGallery}
            >
              <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="3" y1="9" x2="21" y2="9"></line>
                <line x1="3" y1="15" x2="21" y2="15"></line>
                <line x1="9" y1="21" x2="9" y2="9"></line>
                <line x1="15" y1="21" x2="15" y2="9"></line>
              </svg>
              <span>{showHidden ? 'Show less' : 'View all images'}</span>
            </button>
          </div>
        </div>
      </div>

      <style>{`
        #gallery {
          background: linear-gradient(135deg, #CCFBF1 0%, #E6FFFA 100%);
          padding: 6rem 2rem;
          margin: 0;
          width: 100%;
          position: relative;
          overflow: hidden;
        }

        #gallery::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, #14B8A6, transparent);
        }

        .gallery-container {
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .section-header {
          text-align: center;
          margin-bottom: 3rem;
        }

        .section-header h2 {
          font-size: clamp(2rem, 5vw, 3rem);
          color: #0F172A;
          position: relative;
          display: inline-block;
          font-weight: 700;
          margin-bottom: 0.5rem;
          letter-spacing: -0.02em;
        }

        .section-header h2:after {
          content: '';
          display: block;
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #14B8A6, #0D9488);
          margin: 1rem auto 0;
          border-radius: 2px;
        }

        .section-subtitle {
          color: #334155;
          font-size: 1.1rem;
          margin-top: 1rem;
        }

        .gallery-wrapper {
          width: 100%;
          background: transparent;
        }

        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 1.5rem;
          width: 100%;
          margin: 0 auto;
          padding: 0.5rem;
        }

        .third-row {
          margin-top: 1.5rem;
        }

        .gallery-item {
          cursor: pointer;
          border: none;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          width: 100%;
          aspect-ratio: 1 / 1;
          opacity: 0;
          transform: translateY(20px);
          animation: fadeInUp 0.6s ease forwards;
        }

        .image-wrapper {
          width: 100%;
          height: 100%;
          border-radius: 12px;
          overflow: hidden;
          background: white;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1rem;
        }

        .gallery-item:hover .image-wrapper {
          transform: translateY(-8px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }

        .gallery-item img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          filter: brightness(1);
        }

        .gallery-item:hover img {
          transform: scale(1.08);
        }

        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .slide-up {
          animation: slideUp 0.5s ease forwards;
        }

        @keyframes slideUp {
          0% {
            opacity: 0;
            transform: translateY(30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .gallery-btn-wrapper {
          display: flex;
          justify-content: center;
          margin-top: 3.5rem;
          width: 100%;
        }

        .btn-gallery {
          background: linear-gradient(135deg, #f59e0b, #d97706);
          border: none;
          color: white;
          padding: 1rem 2.8rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 0.8rem;
          transition: all 0.3s ease;
          font-size: 1rem;
          box-shadow: 0 4px 6px -1px rgba(245, 158, 11, 0.3), 0 2px 4px -1px rgba(217, 119, 6, 0.2);
          position: relative;
          overflow: hidden;
        }

        .btn-gallery::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #fbbf24, #f59e0b);
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: 1;
        }

        .btn-gallery:hover {
          transform: translateY(-2px);
          box-shadow: 0 20px 25px -5px rgba(245, 158, 11, 0.4), 0 10px 10px -5px rgba(217, 119, 6, 0.3);
        }

        .btn-gallery:hover::before {
          opacity: 1;
        }

        .btn-gallery span,
        .btn-gallery .btn-icon {
          position: relative;
          z-index: 2;
          transition: all 0.3s ease;
        }

        .btn-icon {
          width: 20px;
          height: 20px;
          transition: transform 0.5s ease;
        }

        .btn-gallery:hover .btn-icon {
          transform: rotate(180deg);
        }

        /* Scroll reveal animation */
        .reveal {
          opacity: 0;
          transform: translateY(40px);
          transition: all 0.9s cubic-bezier(0.2, 0.9, 0.3, 1);
        }

        .reveal.active {
          opacity: 1;
          transform: translateY(0);
        }

        /* Loading animation */
        .animate-on-scroll {
          opacity: 0;
          transform: translateY(20px);
          animation: fadeInUp 0.6s ease forwards;
        }

        /* Responsive design */
        @media (max-width: 1200px) {
          .gallery-grid {
            gap: 1rem;
          }
        }

        @media (max-width: 992px) {
          .gallery-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 1rem;
          }
          
          .gallery-grid:first-of-type {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 768px) {
          #gallery {
            padding: 4rem 1rem;
          }
          
          .gallery-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.8rem;
          }
          
          .gallery-grid:first-of-type {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .section-subtitle {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .gallery-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.5rem;
            padding: 0.25rem;
          }
          
          .btn-gallery {
            padding: 0.8rem 2rem;
            font-size: 0.9rem;
          }
          
          .image-wrapper {
            padding: 0.5rem;
          }
        }

        /* Smooth scrolling for the whole page */
        html {
          scroll-behavior: smooth;
        }
      `}</style>
    </section>
  );
};

export default Gallery;